module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Expense Table Component Example")]), _vm._v(" "), _c('expense-table-component', {
    attrs: {
      "show-debug": false
    },
    on: {
      "expenses-saved": _vm.handleExpensesSaved
    }
  }), _vm._v(" "), (_vm.savedExpensesHistory.length > 0) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('h4', [_vm._v("Saved Expenses History:")]), _vm._v(" "), _vm._l((_vm.savedExpensesHistory), function(batch, batchIndex) {
    return _c('div', {
      key: batchIndex,
      staticClass: "mb-4"
    }, [_c('b-card', [_c('h6', [_vm._v("Batch " + _vm._s(batchIndex + 1) + " - " + _vm._s(batch.timestamp))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, _vm._l((batch.expenses), function(expense, index) {
      return _c('div', {
        key: index,
        staticClass: "col-md-6 mb-2"
      }, [_c('b-card', {
        staticClass: "h-100",
        attrs: {
          "variant": "light"
        }
      }, [_c('small', [_c('strong', [_vm._v(_vm._s(_vm.getExpenseText(expense.natureOfExpense)))]), _c('br'), _vm._v("\n                Incurred: " + _vm._s(expense.expenseIncurred)), _c('br'), _vm._v(" "), (expense.expenseIncurred === 'Yes') ? _c('span', [_vm._v("\n                  Amount to Pay: $" + _vm._s(expense.amountToBePaid)), _c('br')]) : _vm._e(), _vm._v("\n                Bill to Shipper: " + _vm._s(expense.billToShipper)), _c('br'), _vm._v(" "), (expense.billToShipper === 'Yes') ? _c('span', [_vm._v("\n                  Amount to Bill: $" + _vm._s(expense.amountToBeBilled) + " (" + _vm._s(_vm.getBillToText(expense.billToType)) + ")"), _c('br')]) : _vm._e()])])], 1)
    }))])], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bad4daa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/expenseTableExample.vue
// module id = 2425
// module chunks = 0